import { Component, OnInit } from '@angular/core';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd, NavigationEnd } from '@angular/router';
import { Constants } from './app.constants';
import { UserService } from './user/user.service';
import { HttpClient } from '@angular/common/http';
import { OrgService } from './organization/org.service';
import { PatientService } from './patient/patient.service';
import { Role } from './common';
import { NgxSpinnerService } from 'ngx-spinner';
import { OrgInfo } from './organization/org-info';
declare let gtag: Function;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  template: string;
  url: any;
  constructor(
      private spinner: NgxSpinnerService
    , private router: Router
    , private userService: UserService
    , private http: HttpClient
    , private orgservice: OrgService
    , private patientService: PatientService) {
    this.url = window.location.hostname;
    window.onbeforeunload = () => {
      const currentUrl = this.router.url;
      if (!currentUrl.includes('signin') && !currentUrl.includes('signup')) {
        this.userService.deleteActiveLogin(this.userService.CurrentUser ? this.userService.CurrentUser.userId : null);
      }
      if (!currentUrl.includes('clinicianvideo/participantprofile/') && !currentUrl.includes('clinicianvideo/editparticipantprofile/') && !currentUrl.includes('docview/') && !currentUrl.includes('signin')) {
        if (!currentUrl.includes('clinicianvideo/casemanagement/show') && !currentUrl.includes('clinicianvideo/show') && !currentUrl.includes('clientvideo/show')) {
          this.userService.onclosedevent(this.userService.CurrentUser ? this.userService.CurrentUser.userId : null);
        } else {
          const role = this.userService != undefined && this.userService.CurrentUser != undefined ? this.userService.CurrentUser.roles[0] : '';
          let isClient = false;
          if (role != '' && role != undefined) {
            isClient = role == Role.Patient || role == Role.Participants ? true : false;
          }
          const sessionId = this.userService.getSessionStorageItem('SessionId');
          this.patientService.onclosedevent(this.userService.CurrentUser ? this.userService.CurrentUser.userId : null, isClient, sessionId);
        }
      }
    };
     // subscribe to router events and send page views to Google Analytics
    //  this.router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
    //     gtag('set', 'page', event.urlAfterRedirects);
    //     gtag('send', 'pageview');
    //   }
    // });
  }

  ngOnInit(): void {
    this.readingJson();
    this.router.events.subscribe(event => {
      // To show loading spinner, while lazy loading modules
      if (event instanceof RouteConfigLoadStart) {
        // this.loadingSpinner.show();
        this.spinner.show();
      } else if (event instanceof RouteConfigLoadEnd) {
       // this.loadingSpinner.hide();
       this.spinner.hide();
      }
      // To send event to Google Analytics
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }

  readingJson() {
    // reading jason
    let json = Constants.Apportis;
    if (this.userService.CurrentUser != undefined && this.userService.CurrentUser.resourceFilePath != undefined && this.userService.CurrentUser.resourceFilePath != '') {
      if (this.userService.CurrentUser.resourceFilePath != undefined) {
        json = this.userService.CurrentUser.resourceFilePath;
      }
      this.http.get('assets/org-translate/' + json + '.json').subscribe(data => {
        this.userService.setSessionItem(JSON.stringify(data), Constants.OrgSpecificResource);
      });
    } else {
      const cname = { 'cname': this.url };
      this.userService.IsCheckOrgType = true;
      this.orgservice.checkorgansiationtype(cname).subscribe((res: OrgInfo) => {
        this.userService.OrgInfo.next(res);
        if (res.resourceFilePath != undefined && res.resourceFilePath != '' && res.resourceFilePath != null) {
          json = res.resourceFilePath;
        }
        this.http.get('assets/org-translate/' + json + '.json').subscribe(data => {
          this.userService.setSessionItem(JSON.stringify(data), Constants.OrgSpecificResource);
        });
      });
    }

  }
}
